import React, { useState } from "react";
import { failed, success } from "../../common/Toastify";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { QuestionsFormikObj } from "./Constant";
import { Tooltip } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { createQuestion } from "../../api/Questionnaire";
import { QuestionForm } from "./QuestionForm";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { validation, conditionalValidation } from "../../../utils/constants";

const CreateQuestion = () => {
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [tagValue, setTagValue] = useState();
  const userOrg = useSelector((s) => s?.auth?.user?.["custom:orgId"]);

  const channelDataMap = { id: Date.now(), text: "Phone" };

  const formik = useFormik({
    ...QuestionsFormikObj,
    initialValues: {
      ...QuestionsFormikObj.initialValues,
      orgId: userOrg || "",
      category: "",
    },
    validationSchema: Yup.object({
      orgId: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Organization",
          mandatory: true
        }),
      category: conditionalValidation(
          Yup.string()
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
          {
            mandatory: true,
            validation,
            label: "Category"
          }),
      question: conditionalValidation(
          Yup.string()
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.")
          .max(400, "Must be 400 characters or less"),
          {
            validation,
            label:"Question",
            mandatory: true
          }),
      answerType: conditionalValidation(
          Yup.string()
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
          {
            validation,
            label: "Answer Type",
            mandatory: true
          }),
      note: conditionalValidation(
          Yup.string()
          .when("answerType", (answerType, schema) => {
            if (answerType === "freeText" || answerType === "singleFreeText")
              return schema
                .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.");
            return schema;
          })
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.")
          .max(250, "Must be 250 characters or less"),
          {
            validation,
            label: "Note"
          }),
      required: Yup.boolean(),
      options: Yup.array().when(["answerType", "tag"], (answerType, tag, schema) => {
        if (answerType !== "freeText" && answerType !== "singleFreeText" && tag !== "CHANNEL")
          return schema.of(
            Yup.object().shape({
              text: conditionalValidation(
                Yup.string(),
                {
                  validation,
                  label: "Answer",
                  mandatory: true
                })
            })
          );
        if (tag === "CHANNEL")
          return schema.of(
            Yup.object().shape({
              text: conditionalValidation(
                Yup.string(),
                {
                  validation,
                  label: "Chat/Video",
                  mandatory: true
                }),
            })
          );
        return schema;
      }),
    }),
    onSubmit: (values) => {
      values.question = values.question?.trim();
      values.note = values.note?.trim();
      values.options = values.options?.map((option) => ({
        ...option,
        text: option.text?.trim(),
      }));
      setBtnLoading(true);
      values.tag = tagValue;

      if (
        tagValue === "CHANNEL" ||
        tagValue === "TELEPHONE" ||
        tagValue === "REASON" ||
        tagValue === "CALLER" ||
        tagValue === "LOCATION" ||
        tagValue === "RELATIONSHIP" ||
        tagValue === "SELFCALLING" ||
        tagValue === "CONSENT" ||
        tagValue === "INCLINATION" ||
        tagValue === "COMPLIANCE"
      ) {
        values.required = true;
      }

      if (values.tag === "CHANNEL") {
        const hasPhone = (values.options || []).some((o) => o.text === "Phone");
        if (!hasPhone) {
          values.options = [...(values.options || []), channelDataMap];
        }
      }

      const payload = {
        ...values,
        orgId: values.orgId || userOrg,
        category: values?.category?.split("%")?.[1] || "",
      };

      createQuestion(payload)
        .then((res) => {
          navigate("/app/manage-questions");
          success(res.message);
        })
        .catch((res) => {
          const errorMessage =
            res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message;
          failed(errorMessage);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .finally(() => setBtnLoading(false));
    },
  });

  const handleQuestionTagValue = (value) => {
    if (typeof value === "string") setTagValue(value);
    if (typeof value === "object") {
      navigate("/app/create-questions");
      return;
    }
  };

  return (
    <section className="common-listing">
      <div className="heading-wrap mb-3">
        <Tooltip title="Go back">
          <div style={{ marginRight: "1rem", cursor: "pointer" }} onClick={() => navigate(-1)}>
            <ArrowBack />
          </div>
        </Tooltip>
      </div>
      <div className="custom-card p-4">
        <QuestionForm
          btnLoading={btnLoading}
          formik={formik}
          handleShow={() => navigate("/app/manage-questions")}
          isCreate={true}
          handleQuestionTagValue={handleQuestionTagValue}
          enableOrgChange={true}
        />
      </div>
    </section>
  );
};

export default CreateQuestion;